import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=cd2dfc9a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=cd2dfc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2dfc9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd2dfc9a')) {
      api.createRecord('cd2dfc9a', component.options)
    } else {
      api.reload('cd2dfc9a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=cd2dfc9a&scoped=true&", function () {
      api.rerender('cd2dfc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kjhXTu6FEcEZ/JS/comp/DocBox.vue"
export default component.exports